import React from 'react';

import {FlatButton} from '@pb/kit-component-button';
import {DropdownMenu, DropdownMenuItem} from '@pb/kit-component-dropdown-menu';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';

type Props = {
    showUpdateGroup: boolean,
    openAssignToGroup: () => void,
    openDischargeFromGroup: () => void,

    showUpdateDeviceRegistration: boolean,
    openEnableDeviceRegistration: () => void,
    openDisableDeviceRegistration: () => void,

    showUpdateMfaSettings: boolean,
    openEnableMfaSettings: () => void,
    openDisableMfaSettings: () => void,

    showUpdateUserState: boolean,
    openUpdateUserStateTool: () => void,

    showUpdateUserNewsletter: boolean,
    openUpdateUserNewsletterTool: () => void,

    showUpdateUserAccount: boolean,
    openUpdateUserAccountTool: () => void,

    showSendWelcomeEmail: boolean,
    openSendWelcomeEmailTool: () => void,

    showUpdateLcdAnalysis: boolean,
    openSubscribeToLcdAnalysisTool: () => void,
    openUnsubscribeFromLcdAnalysisTool: () => void,

    showUpdateUserEntitlements: boolean,
    openUsersEntitlementsAssignTool: () => void,
    openUsersEntitlementsDischargeTool: () => void,
    showAssignProductSeat: boolean,
    openAssignProductSeat: () => void,
    showUnassignProductSeat: boolean,
    openUnassignProductSeat: () => void,
};

export const UsersGroupsToolsRibbonRow = (props: Props) => (
    <Group>
        {props.showUpdateGroup ? (
            <DropdownMenu
                anchor={({positionRef, getAnchorProps, anchorRef}) => (
                    <FlatButton
                        endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                        {...getAnchorProps()}
                        ref={anchorRef}>
                        <b>Set Account Group</b>
                    </FlatButton>
                )}>
                <DropdownMenuItem
                    caption="Assign To Group"
                    onClick={props.openAssignToGroup}
                />
                <DropdownMenuItem
                    caption="Unassign From Group"
                    onClick={props.openDischargeFromGroup}
                />
            </DropdownMenu>
        ) : null}
        {props.showUpdateDeviceRegistration ? (
            <DropdownMenu
                anchor={({positionRef, getAnchorProps, anchorRef}) => (
                    <FlatButton
                        endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                        {...getAnchorProps()}
                        ref={anchorRef}>
                        <b>Device Registration</b>
                    </FlatButton>
                )}>
                <DropdownMenuItem
                    caption="Enable Device Registration"
                    onClick={props.openEnableDeviceRegistration}
                />
                <DropdownMenuItem
                    caption="Disable Device Registration"
                    onClick={props.openDisableDeviceRegistration}
                />
            </DropdownMenu>
        ) : null}
        {props.showUpdateMfaSettings ? (
            <DropdownMenu
                anchor={({positionRef, getAnchorProps, anchorRef}) => (
                    <FlatButton
                        endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                        {...getAnchorProps()}
                        ref={anchorRef}>
                        <b>MFA Settings</b>
                    </FlatButton>
                )}>
                <DropdownMenuItem
                    caption="Enable Multi-Factor Authentication"
                    onClick={props.openEnableMfaSettings}
                />
                <DropdownMenuItem
                    caption="Disable Multi-Factor Authentication"
                    onClick={props.openDisableMfaSettings}
                />
            </DropdownMenu>
        ) : null}
        {props.showUpdateLcdAnalysis ? (
            <DropdownMenu
                anchor={({positionRef, getAnchorProps, anchorRef}) => (
                    <FlatButton
                        endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                        {...getAnchorProps()}
                        ref={anchorRef}>
                        <b>LCD Credit Analysis</b>
                    </FlatButton>
                )}>
                <DropdownMenuItem
                    caption="Subscribe"
                    onClick={props.openSubscribeToLcdAnalysisTool}
                />
                <DropdownMenuItem
                    caption="Unsubscribe"
                    onClick={props.openUnsubscribeFromLcdAnalysisTool}
                />
            </DropdownMenu>
        ) : null}
        {props.showUpdateUserEntitlements ? (
            <DropdownMenu
                anchor={({positionRef, getAnchorProps, anchorRef}) => (
                    <FlatButton
                        endIcon={<Icon type={Icons.ANGLE_DOWN} ref={positionRef}/>}
                        {...getAnchorProps()}
                        ref={anchorRef}>
                        <b>Update Users Entitlements</b>
                    </FlatButton>
                )}>
                <DropdownMenuItem
                    caption="Assign"
                    onClick={props.openUsersEntitlementsAssignTool}
                />
                <DropdownMenuItem
                    caption="Unassign"
                    onClick={props.openUsersEntitlementsDischargeTool}
                />
            </DropdownMenu>
        ) : null}
        {props.showAssignProductSeat ? (
            <FlatButton onClick={props.openAssignProductSeat}><b>Assign Product Seat</b></FlatButton>
        ) : null}
        {props.showUnassignProductSeat ? (
            <FlatButton onClick={props.openUnassignProductSeat}><b>Unassign Product Seat</b></FlatButton>
        ) : null}
        {props.showUpdateUserState ? (
            <FlatButton onClick={props.openUpdateUserStateTool}>
                <b>Set User State</b>
            </FlatButton>
        ) : null}
        {props.showUpdateUserNewsletter ? (
            <FlatButton onClick={props.openUpdateUserNewsletterTool}>
                <b>Set Newsletter Subscriptions</b>
            </FlatButton>
        ) : null}
        {props.showUpdateUserAccount ? (
            <FlatButton onClick={props.openUpdateUserAccountTool}>
                <b>Change User's Account</b>
            </FlatButton>
        ) : null}
        {props.showSendWelcomeEmail ? (
            <FlatButton onClick={props.openSendWelcomeEmailTool}>
                <b>Send Welcome Email</b>
            </FlatButton>
        ) : null}
    </Group>
);
